import { faFaceSmile, faWrench } from '@fortawesome/pro-light-svg-icons';
import { Badge, Icon, SupportedIcon } from 'corso-admin-ui';
import {
  CrewClaimResolutionMethodEnum,
  crewClaimResolutionMethodEnumName,
} from 'corso-types';
import { ComponentProps, PropsWithChildren } from 'react';

const resolutionMethodToBadgeVariant: Record<
  CrewClaimResolutionMethodEnum,
  ComponentProps<typeof Badge>['variant']
> = {
  [CrewClaimResolutionMethodEnum.giftCard]: 'info',
  [CrewClaimResolutionMethodEnum.variantExchange]: 'success',
  [CrewClaimResolutionMethodEnum.refund]: 'danger',
  [CrewClaimResolutionMethodEnum.replacementOrder]: 'success',
  [CrewClaimResolutionMethodEnum.warrantyReview]: 'info',
  // for completeness, the rest are default
  [CrewClaimResolutionMethodEnum.repair]: 'default',
  [CrewClaimResolutionMethodEnum.other]: 'default',
};

const resolutionMethodToIcon: Record<
  CrewClaimResolutionMethodEnum,
  SupportedIcon
> = {
  [CrewClaimResolutionMethodEnum.giftCard]: 'giftCard',
  [CrewClaimResolutionMethodEnum.variantExchange]: 'exchange',
  [CrewClaimResolutionMethodEnum.refund]: 'payment',
  [CrewClaimResolutionMethodEnum.replacementOrder]: 'box',
  [CrewClaimResolutionMethodEnum.warrantyReview]: 'verified',
  // for completeness, the rest are default
  [CrewClaimResolutionMethodEnum.repair]: faWrench,
  [CrewClaimResolutionMethodEnum.other]: faFaceSmile,
};

export default function ResolutionMethodBadge({
  resolutionMethod,
  icon = false,
  children,
}: PropsWithChildren<{
  resolutionMethod: CrewClaimResolutionMethodEnum;
  icon?: boolean;
}>) {
  return (
    <Badge variant={resolutionMethodToBadgeVariant[resolutionMethod]}>
      {icon && <Icon icon={resolutionMethodToIcon[resolutionMethod]} />}
      {crewClaimResolutionMethodEnumName[resolutionMethod]}
      {children}
    </Badge>
  );
}
